// extracted by mini-css-extract-plugin
export default {"overlay":"StudentNotesModal_overlay__wPjmq modal-overlay-enter","modal":"StudentNotesModal_modal__s21yY modal-panel-enter","modalCompact":"StudentNotesModal_modalCompact__F+YKa"};